import React from 'react';
import Slider from 'react-slick';

const ExperienceSlider = ({ experienceKey = '', images = [], style = {} }) => {
  if (!Array.isArray(images) || images.length === 0) {
    return null;
  }

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
  };

  const sliderClassName = ['slider', 'experience-slider', experienceKey ? `experience-slider--${experienceKey}` : '']
    .filter(Boolean)
    .join(' ');

  return (
    <section className={sliderClassName} style={style}>
      <div className="inner experience-slider__inner">
        <Slider {...settings}>
          {images.map((imageSrc, index) => (
            <div
              key={`experience-slider-${index}`}
              className={`experience-slider__slide experience-slider__slide--${index + 1}`}
            >
              <img className="experience-slider__image" src={imageSrc} alt="" />
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default ExperienceSlider;
